<template>
  <div class="uk-width-expand@m">
    <div class="bb-options summary">
      <p class="label">Summary:</p>
      <SummaryTable v-if="selected_size != null" />
      <NextButtons
      prev_route="mattress" />
    </div>

  </div>
</template>
<script>
import SummaryTable from "../components/SummaryTable.vue";
import {mapState} from 'vuex';
import NextButtons from '../components/NextButtons.vue';
export default {

  name: "summary-view",
  components: {
    SummaryTable,
    NextButtons
  },
  computed : {
    ...mapState({
      selected_size : state => state.selected_size
    })
  }
};
</script>